import { rebuildFieldTypesConfig } from '@databases/fields';

/**
 * At the start of the application this rebuilds the field type config
 * that is dynamic and dependent on the value of feature flags.
 */
export function initializeFieldTypesConfig(
  params: Parameters<typeof rebuildFieldTypesConfig>[0],
): void {
  rebuildFieldTypesConfig(params);
}
